import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { LayoutDashboard, Sun, Moon, LogOut } from 'lucide-react';
import { useVendorAuth } from '../guards/RequireVendorAuth';
import { useTheme } from '../../providers/ThemeProvider';

export function VendorLayout() {
  const { vendor, logout } = useVendorAuth();
  const { theme, toggleTheme } = useTheme();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/vendor/login');
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-[#0a0a0a]">
      {/* Header — Teal gradient */}
      <nav className="bg-gradient-to-r from-[#0f766e] to-[#115e59] dark:bg-[#111] dark:from-[#111] dark:to-[#111] dark:border-b dark:border-gray-800 text-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex justify-between items-center py-2">
            <NavLink to="/vendor/dashboard" className="flex items-center hover:opacity-90 transition-opacity">
              <img
                src="https://www.restroworks.com/wp-content/uploads/2025/04/Restroworks-White.png"
                alt="Connect"
                className="h-[28px]"
              />
              <span className="ml-2 text-lg font-semibold tracking-wide text-white/90">Connect</span>
            </NavLink>

            <div className="flex items-center space-x-2">
              <NavLink
                to="/vendor/dashboard"
                className={({ isActive }) =>
                  `flex items-center gap-1.5 px-2.5 py-1.5 rounded-md text-xs font-medium transition-colors ${
                    isActive ? 'bg-white/15 text-white' : 'text-white/70 hover:text-white hover:bg-white/10'
                  }`
                }
              >
                <LayoutDashboard size={14} />
                Dashboard
              </NavLink>

              <div className="w-px h-4 bg-white/20 mx-1" />

              <button onClick={toggleTheme} className="p-1.5 rounded-md text-white/70 hover:text-white hover:bg-white/10" title="Toggle dark mode">
                {theme === 'dark' ? <Sun size={14} /> : <Moon size={14} />}
              </button>

              <span className="text-xs text-white/70">{vendor?.name}</span>

              <button onClick={handleLogout} className="flex items-center gap-1 px-2 py-1.5 rounded-md text-xs text-white/70 hover:text-white hover:bg-white/10">
                <LogOut size={14} />
              </button>
            </div>
          </div>
        </div>
      </nav>

      <main className="max-w-7xl mx-auto px-4 py-4">
        <Outlet />
      </main>
    </div>
  );
}
